module.exports = __webpack_public_path__ + "img/Boton_App.7a08517d.png";